const CodebookType = ["🥳", "👬", "🤝", "🏳️‍🌈", "🍋", "🃟", "🀁"];
const CodebookTypeTitle = ["表情", "手拉手", "手势", "旗帜", "食物", "扑克", "麻将"];

export {
    CodebookType,
    CodebookTypeTitle
}